import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import SectionHeading from "@/components/base/SectionHeading";
import PosterCard from "@/components/base/PosterCard";
import { usePageMeta } from "@/hooks/usePageMeta";
import { getFeatured, getHot, getLatest } from "@/lib/media";
import { mediaList } from "@/mocks/media";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import NewsTicker from "@/pages/home/components/NewsTicker";
import HotRanking from "@/pages/home/components/HotRanking";
import NewsHighlights from "@/pages/home/components/NewsHighlights";

export default function Home() {
  usePageMeta(
    "欧美日韩影视平台-最新日韩欧美电影电视剧在线观看",
    "欧美日韩网站为您提供丰富的日韩、欧美电影电视剧资讯和影视内容，覆盖多种类别，方便用户了解最新影视动态和精彩剧集。",
    "欧美日韩,日韩影视,欧美电影,电视剧,影视资讯,最新影视,影视推荐",
  );

  const featured = getFeatured();
  const latest = getLatest(10);
  const hot = getHot(10);
  const topRated = [...mediaList].sort((a, b) => b.rating - a.rating).slice(0, 6);

  return (
    <SiteLayout>
      <HeroCarousel items={featured} />
      <CategoryShortcuts />
      <NewsTicker />

      <section className="w-full px-4 md:px-8 mt-12 md:mt-14">
        <SectionHeading
          title="最新上映影视推荐"
          subtitle="汇集近期上线的电影与剧集，第一时间了解新片动态"
          moreLink="/category/movie"
          moreText="浏览全部电影"
        />
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {latest.map((item) => (
            <PosterCard key={item.id} item={item} />
          ))}
        </div>
      </section>

      <section className="w-full px-4 md:px-8 mt-12 md:mt-14">
        <SectionHeading
          title="热门影视精选"
          subtitle="根据播放热度与用户评分综合推荐"
          moreLink="/category/tv"
          moreText="浏览全部剧集"
        />
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-5 md:gap-6">
          <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
            {hot.map((item) => (
              <PosterCard key={item.id} item={item} />
            ))}
          </div>
          <aside className="lg:col-span-1">
            <div className="mb-3 flex items-center gap-2">
              <i className="ri-trophy-fill text-accent-500" />
              <h3 className="text-sm font-bold text-foreground-950 font-heading">
                高分口碑榜
              </h3>
            </div>
            <HotRanking items={topRated} />
          </aside>
        </div>
      </section>

      <section className="w-full px-4 md:px-8 mt-12 md:mt-14">
        <SectionHeading
          title="影视资讯快讯"
          subtitle="行业动态、票房与剧集最新报道"
          moreLink="/category/news"
          moreText="查看全部资讯"
        />
        <NewsHighlights />
      </section>

      <section className="w-full px-4 md:px-8 mt-12 md:mt-14">
        <div className="rounded-lg bg-primary-50 border border-primary-100 p-6 md:p-8 grid grid-cols-1 lg:grid-cols-3 gap-6 items-center">
          <div className="lg:col-span-2">
            <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">
              关于「欧美日韩」影视平台
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600 leading-relaxed">
              我们聚焦日韩与欧美地区的电影、电视剧内容，提供最新的影视资讯、分类浏览与剧集详情。无论你是追剧党还是资讯阅读者，都能在这里快速找到想看的内容。
            </p>
          </div>
          <div className="flex lg:justify-end">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}